import {
    Button,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
} from "@chakra-ui/react";
import { FC, useContext, useEffect } from "react";
import { useRegulation } from "../../../../hooks/useRegulation";
import { LoginStateContext } from "../../LoginState";
import { useQueryClient } from 'react-query';
import { deleteJSON } from "../../../../api/http";
import { endpoints } from "../../../../api/endpoints";



export interface IRegulationModal {
    modalHeader?: string;
    noButton?: boolean;
    onCloseModal?: Function;
}

export const RegulationModal: FC<IRegulationModal> = ({
    modalHeader,
    noButton,
    onCloseModal
}) => {
    const { isOpen, onOpen, onClose } = useDisclosure(),
        onFormClose = () => {
            if (noButton) {
                onClose();
            }
            if (onCloseModal) {
                onCloseModal();
            }
        },
        { data, acceptRegulation } = useRegulation(onClose),
        { dispatch } = useContext(LoginStateContext),
        queryClient = useQueryClient(),
        deleteLogout = async () => deleteJSON(endpoints.auth),
        onSubmit = () => {
            acceptRegulation();
        },
        handleLogout = () => {
            deleteLogout();
            queryClient.invalidateQueries();
            queryClient.cancelQueries();
            queryClient.clear();
            dispatch({ type: 'NOT_LOGGED' });
        };

    useEffect(() => {
        if (!isOpen) {
            onOpen();
        }
    }, [data, isOpen, onOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onFormClose} closeOnOverlayClick={false}>
            <ModalOverlay onClick={onFormClose} />
            <ModalContent minW={["100%", "100%", "500px"]}
                minH={["100%", "100%", "initial"]}
                m={["0px", "0px", "60px 0px"]}
                borderRadius={["0px", "0px", "10px"]}>
                <ModalHeader color="darkPrimary">{modalHeader ? modalHeader : 'Zmiana regulaminu'}</ModalHeader>
                <ModalCloseButton onClick={handleLogout} />
                <ModalBody>
                    {data &&
                        <div dangerouslySetInnerHTML={{ __html: data.html }} />
                    }
                </ModalBody>
                <ModalFooter>
                    <Flex justifyContent="center"
                        w="100%"
                        flexDir={["column-reverse", "column-reverse", "row"]}>
                        {!noButton &&
                            <Button backgroundColor="lightPrimary"
                                _hover={{ backgroundColor: "lighterPrimary" }}
                                color="white"
                                p="10px 30px"
                                size="sm"
                                h="35px"
                                onClick={() => {
                                    onFormClose()
                                    onSubmit()
                                }}>
                                Akceptuję
                            </Button>
                        }
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
